import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { ArrowLeft, LockKeyhole } from 'lucide-react'
import { Button, Notice } from '../components/Ui'
import { useAuth } from '../state/auth'
import { BrandLogo } from '../components/BrandLogo'

export function PasswordResetPage() {
  const { configured, loading, user, updatePassword, signOut } = useAuth()
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault()
    setError('')
    if (password !== confirm) {
      setError('Konfirmasi kata sandi belum sama.')
      return
    }
    setSubmitting(true)
    try {
      await updatePassword(password)
      await signOut()
      setDone(true)
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Kata sandi belum bisa diubah. Coba lagi.')
    } finally {
      setSubmitting(false)
    }
  }

  return <main className="reset-page"><section className="reset-panel">
    <div className="sidebar__brand"><BrandLogo /><span><strong>Dhuwit</strong><small>Keuangan jadi mudah</small></span></div>
    <span className="eyebrow">Keamanan akun</span>
    <h1>Atur ulang kata sandi</h1>
    <p>Gunakan kata sandi baru untuk masuk kembali ke Dhuwit.</p>
    {!configured ? <Notice tone="danger">Supabase belum terhubung.</Notice> : null}
    {!loading && !user && !done ? <Notice tone="danger">Tautan pemulihan tidak aktif atau sudah kedaluwarsa. Minta tautan baru dari halaman masuk.</Notice> : null}
    {error ? <Notice tone="danger">{error}</Notice> : null}
    {done ? <Notice tone="success">Kata sandi berhasil diubah. Silakan masuk kembali.</Notice> : null}
    {!done && user ? <form className="login-email-form" onSubmit={(event) => void submit(event)}>
      <label>Kata sandi baru<input type="password" autoComplete="new-password" minLength={8} required value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Minimal 8 karakter" /></label>
      <label>Ulangi kata sandi<input type="password" autoComplete="new-password" minLength={8} required value={confirm} onChange={(event) => setConfirm(event.target.value)} placeholder="Ulangi kata sandi baru" /></label>
      <Button type="submit" loading={submitting} loadingLabel="Menyimpan..."><LockKeyhole size={16} aria-hidden="true" />Simpan kata sandi</Button>
    </form> : null}
    <Link className="reset-back" to="/login"><ArrowLeft size={17} aria-hidden="true" />Kembali ke masuk</Link>
  </section></main>
}
